import React from 'react';
import { Checkbox, Col, Form } from 'antd';
import BaseSelect from '../Elements/BaseSelect';

const STAFF_FIELDS = [
    ['examination_doctor_ids', 'Bác sĩ khám', 'Chọn một hoặc nhiều bác sĩ khám'],
    ['treatment_doctor_ids', 'Bác sĩ điều trị', 'Chọn một hoặc nhiều bác sĩ trực tiếp điều trị'],
    ['implant_doctor_ids', 'Bác sĩ cắm trụ', 'Chọn một hoặc nhiều bác sĩ cắm trụ', true],
    ['prosthetic_doctor_ids', 'Bác sĩ phục hình', 'Chọn một hoặc nhiều bác sĩ phục hình', true],
    ['apprentice_doctor_ids', 'Bác sĩ học việc', 'Chọn một hoặc nhiều bác sĩ học việc'],
];

/** Các vai trò bác sĩ độc lập; cùng một nhân viên có thể được chọn ở nhiều vai trò. */
export default function CustomerServiceIndependentStaffFields({ item, doctors = [], isImplant, onChangeItem, formItemStyle }) {
    return <>
        {STAFF_FIELDS.filter(([, , , implantOnly]) => !implantOnly || isImplant).map(([field, label, placeholder]) => (
            <Col xs={24} md={12} key={field}>
                <Form.Item label={label} style={formItemStyle}>
                    <BaseSelect
                        options={doctors}
                        optionValue="user_id"
                        optionLabel="display_name"
                        mode="multiple"
                        showSearch
                        allowClear
                        disabled={item.direct_doctor_unknown === true && ['treatment_doctor_ids', 'implant_doctor_ids', 'prosthetic_doctor_ids'].includes(field)}
                        placeholder={placeholder}
                        style={{ width: '100%' }}
                        value={item[field] || []}
                        onChange={(values) => onChangeItem(field, values || [], item.id)}
                    />
                    {field === 'treatment_doctor_ids' && (
                        <Checkbox
                            checked={item.direct_doctor_unknown === true}
                            onChange={(event) => onChangeItem('direct_doctor_unknown', event.target.checked, item.id)}
                            style={{ marginTop: 6 }}
                        >
                            {isImplant ? 'Chưa xác định bác sĩ trực tiếp' : 'Chưa xác định'}
                        </Checkbox>
                    )}
                </Form.Item>
            </Col>
        ))}
    </>;
}
